'use strict';

var novicell = novicell || {};

novicell.gridSection = novicell.gridSection || new function () {
    const gridSections = document.querySelectorAll('.js-grid-section');

    this.init = function () {
        if (!gridSections || gridSections.length <= 0) {
            return;
        }

        novicell.gridSection.fadeSections();

        window.addEventListener('scroll', function (e) {
            novicell.gridSection.fadeSections();
        });
    };

    this.fadeSections = function () {

        for (let i = 0; i < gridSections.length; i++) {
            let currentSection = gridSections[i];

            if (!outOfViewport(currentSection)) {
                currentSection.classList.add('grid-section--in-view');
            }
        }
    };

    function outOfViewport(el) {
        var rect = el.getBoundingClientRect();

        return (rect.bottom - (rect.height / 4)) < 0 || (rect.top + (rect.height / 4)) > window.innerHeight;
    }
};
